import { render, staticRenderFns } from "./Cuatrimestre.vue?vue&type=template&id=2ed9986e"
import script from "./Cuatrimestre.vue?vue&type=script&lang=js"
export * from "./Cuatrimestre.vue?vue&type=script&lang=js"
import style0 from "./Cuatrimestre.vue?vue&type=style&index=0&id=2ed9986e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports